<div class="layout-row layout-align-start-center full-height"
     (mouseenter)="canCopy=true"
     (mouseleave)="canCopy=false">

  <app-bringoz-state-link class="flex text-ellipsis"
                          [state]="'order.info'"
                          [permission]="'oms.orders.get'"
                          [params]="{id: internalId}"
                          [text]="displayId">
  </app-bringoz-state-link>

  <app-text-copy-button *ngIf="canCopy" [text]="displayId" [isShowCopyBtn]="true"></app-text-copy-button>

</div>
